import type { Id } from '@contracts/common';

/**
 * The browser-storage keys that hold card ids of one person (authz audit D-F4). Each is keyed by the user, and when
 * that person's session ends in this tab — "Đăng xuất", a 401, someone else signing in — they are removed, so the
 * next person on this browser finds none of them. What holds no id (the theme, the sidebar, the chosen view, the
 * sharing default) is left alone. Kept here, outside the Workplace chunk, because the shell forgets them.
 */

export const collapsedKey = (userId: Id): string => `workplace:collapsed:${userId}`;
export const recentParentsKey = (userId: Id): string => `h-operation:workplace:recent-parents:${userId}`;
/** The list before it was kept per person: whoever it belonged to, nobody may read it now. */
const LEGACY_RECENT_PARENTS = 'h-operation:workplace:recent-parents';
/** The conversation Hana's panel shows in this tab (sessionStorage): the next person must not open it (P2 review F5). */
export const HANA_CONVERSATION_KEY = 'hana:conversation';

/** Removes `userId`'s id-holding keys, the unkeyed legacy list and Hana's conversation; blocked storage is a no-op. */
export function forgetPerson(userId: Id | undefined): void {
  try {
    const storage = globalThis.localStorage;
    storage.removeItem(LEGACY_RECENT_PARENTS);
    if (userId === undefined) return;
    storage.removeItem(collapsedKey(userId));
    storage.removeItem(recentParentsKey(userId));
  } catch {
    // Storage that throws holds nothing this could remove.
  }
  try {
    globalThis.sessionStorage.removeItem(HANA_CONVERSATION_KEY);
  } catch {
    // As above.
  }
}
